import { render, staticRenderFns } from "./Personality.vue?vue&type=template&id=337b8cbc"
import script from "./Personality.vue?vue&type=script&lang=ts"
export * from "./Personality.vue?vue&type=script&lang=ts"
import style0 from "./Personality.vue?vue&type=style&index=0&id=337b8cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports